<template>
  <div>
    <dashboard-header :text="$t('role.title')"/>
    
    <v-card
        elevation="0"
        class="card-border-10">

      <d-table
          class="pa-10"
          :table-data="roles"
          :fields="fields"
          :loading="loading"
          :edit="isEdit ? editRole : null"
          :on-delete="isDelete ? deleteRole : null"
          :add="isCreate ? addRole : null"
          :get-items="loadRoles"
          :on-delete-content="onDeleteContent"
          :placeholder="$t('role.searchPlaceholder')"
      />
    </v-card>
  </div>
</template>

<script>
import { get, delete2 } from '@/api'
import { API2 } from '@/api'
import DashboardHeader from '../component/DashboardHeader'
import dTable from '../base/DataTable.vue'
import mixin from '@/mixin'
import { PERMISSIONS } from '@/config/permissions'

export default {
  name: 'RoleList',
  mixins: [mixin],
  components: {
    DashboardHeader,
    dTable
  },
  props: {
    openTab: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      search: '',
      roles: []
    }
  },
  computed: {
    isCreate() {
      return this.hasPermission(PERMISSIONS.ROLE_CREATE)
    },
    isEdit() {
      return this.hasPermission(PERMISSIONS.ROLE_UPDATE)
    },
    isDelete() {
      return this.hasPermission(PERMISSIONS.ROLE_DELETE)
    },
    fields() {
      const fields = [
        {
          value: 'name',
          text: this.$t('role.name'),
          sortable: false,
          width: '200px',
        },
        {
          value: 'description',
          text: this.$t('role.description'),
          sortable: false,
          width: '400px',
        },
        // {
        //   value: 'permissionCount',
        //   text: this.$t('role.permissionCount')
        // },
        // {
        //   value: 'userCount',
        //   text: this.$t('role.userCount')
        // },
        // {
        //   value: 'isSystemText',
        //   text: this.$t('role.type')
        // },
        {
          value: 'statusText',
          text: this.$t('role.status'),
          sortable: false,
          width: '100px',
        }
      ]
      
      // Only show actions column if user has any permission
      if (this.isCreate || this.isEdit || this.isDelete) {
        fields.push({
          value: 'actions', 
          sortable: false,
          width: '100px',
        })
      }
      
      return fields
    }
  },
  mounted() {
    this.onTab()
  },
  methods: {
    onTab() {
      this.loadRoles()
    },
    
    async loadRoles(optionParams) {
      this.loading = true
      try {
        // Build query parameters for API call
        let queryParams = ''
        if (optionParams && optionParams.searchKey) {
          queryParams = `?search=${encodeURIComponent(optionParams.searchKey)}`
        }
        
        const response = await get(this, `${API2.ROLE}${queryParams}`)
        if (response && response.data && (response.data.status === 200 || response.data.code === 0)) {
          // Filter out admin default role but keep employee default roles
          this.roles = (response.data.data || []).filter(role => !role.isDefault)
          .filter(role =>role.name !== "Admin Bệnh Viện")
          .map(role => ({
            data: role,
            name: role.name,
            description: role.description || '-',
            permissionCount: role.permissions ? role.permissions.length : 0,
            userCount: 0, // Will be updated by loadUserCount
            isSystemText: role.isDefault ? this.$t('role.system') : this.$t('role.custom'),
            active: role.active,
            statusText: role.active ? this.$t('role.active') : this.$t('role.inactive')
          }))
          
          // Load user count for each role
          for (const role of this.roles) {
            this.loadUserCount(role)
          }
        }
      } catch (error) {
        this.showToast('error', this.$t('common.loadError'))
      } finally {
        this.loading = false
      }
    },
    
    async loadUserCount(role) {
      try {
        const response = await get(this, `${API2.ROLE}/${role.data.id}/users`)
        if (response && response.data && (response.data.status === 200 || response.data.code === 0)) {
          const users = response.data.data || []
          this.$set(role, 'userCount', users.length)
        }
      } catch (error) {
        // Failed to load user count for role
      }
    },
    
    addRole() {
      this.openTab(2)
    },
    
    editRole(role) {
      this.openTab(2, role.data)
    },
    
    async deleteRole(role) {
      if (role.data.isDefault) {
        this.showToast('warning', this.$t('role.cannotDeleteDefault'))
        return
      }
      
      // const confirmed = window.confirm(this.$t('role.deleteConfirmMessage', { name: role.name }))
      
        try {
          const response = await delete2(this, `${API2.ROLE}/${role.data.id}`)
          if (response && response.data && (response.data.status === 200 || response.data.code === 0)) {
            this.showToast('success', this.$t('role.deleteSuccess'))
            this.loadRoles()
          } else {
            // Show specific error message from API response
            const errorMessage = response?.data?.error?.message || response?.data?.message || this.$t('role.deleteError')
            this.showToast('error', errorMessage)
          }
        } catch (error) {
          // Handle network errors or other exceptions
          const errorMessage = error?.response?.data?.error?.message || 
                              error?.response?.data?.message || 
                              error?.message || 
                              this.$t('role.deleteError')
          this.showToast('error', errorMessage)
        }
    },
    
    onDeleteContent(item) {
      return this.$t('role.deleteConfirmMessage', { name: item.name })
    }
  }
}
</script>

<style scoped>
</style>